import { render } from "./mvt-collapse.vue?vue&type=template&id=0d12f9d0"
import script from "./mvt-collapse.js?vue&type=script&lang=js"
export * from "./mvt-collapse.js?vue&type=script&lang=js"

import "./mvt-collapse.vue?vue&type=style&index=0&id=0d12f9d0&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__